module.exports = __webpack_public_path__ + "media/normalfrom.e4bab87e.mp4";